/*
 *   File : index.js
 *   Author URI : https://evoqins.com
 *   Description : Index file to import functions
 *   Integrations : 
 *   Version : v1.1
*/

import { all, fork } from "redux-saga/effects";

import { loginData } from "./sagas";

export function* rootSaga() {
    yield all([fork(loginData)])
};
